/** biome-ignore-all lint/a11y/useKeyWithClickEvents: add accessibility props */
/** biome-ignore-all lint/a11y/noStaticElementInteractions: add accessibility props */
import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {FontsDropdown} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/FontsDropdown/FontsDropdown';
import {UpDownChevron} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/UpDownChevron/UpDownChevron';
import {mapFabricFontToLocal} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/utils';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {useRecentlyUsedFonts} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {useOutsideAlerter} from '~/common/FabricInvitation/EventCreateDesign/hooks/useOutsideAlerter';
import {selectEditorDisabled} from '~/common/fabric/reducers/fabricDesign/selectors';

import './Dropdown.sass';

export const Dropdown = () => {
  const [showMenu, setShowMenu] = useState(false);
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const editorDisabled = useSelector(selectEditorDisabled);
  const [selectedValue, setSelectedValue] = useState();
  const wrapperRef = useRef(null);
  const {recentlyUsedFonts, updateRecentlyUsedFont} = useRecentlyUsedFonts();

  const updateValue = (obj) => {
    setSelectedValue(
      mapFabricFontToLocal({
        fontFamily: obj.fontFamily,
        fontStyle: obj.fontStyle,
        fontWeight: obj.fontWeight,
      })
    );
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const updateActiveObjectValue = () => updateValue(canvas?.getActiveObjects()?.[0] || {});

    updateActiveObjectValue();
    canvas?.on('object:reset', updateActiveObjectValue);

    if (activeObjects?.length === 1) {
      const selectedFont = {
        family: activeObjects?.[0].fontFamily,
        style: activeObjects?.[0].fontStyle,
        weight: activeObjects?.[0].fontWeight,
        name: activeObjects?.[0].fontFamily,
      };
      updateRecentlyUsedFont(selectedFont);
    }
    return () => {
      canvas?.off('object:reset', updateActiveObjectValue);
    };
  }, [canvas, activeObjects]);

  const toggleDropdown = useCallback((e) => {
    e.stopPropagation();
    setShowMenu((prevState) => !prevState);
  }, []);

  const closeMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  useOutsideAlerter(wrapperRef, closeMenu);

  const onChangeHandler = useCallback(
    (value) => {
      setSelectedValue(value);
      activeObjects.forEach((obj) =>
        obj.set({
          fontFamily: value.family,
          fontStyle: value.style,
          fontWeight: value.weight,
        })
      );
      canvas.requestRenderAll();
      canvas.fire('object:modified');

      const selectedFont = {
        family: value.family,
        style: value.style,
        weight: value.weight,
        name: value.name,
      };
      updateRecentlyUsedFont(selectedFont);
    },
    [activeObjects, canvas, updateRecentlyUsedFont]
  );

  return (
    <div className="dropdown_container" ref={wrapperRef}>
      <div
        onClick={editorDisabled ? undefined : toggleDropdown}
        className={`selected_font_wrapper ${editorDisabled && 'selected_font_wrapper--disabled'}`}
        data-qa-id="step1-textstyle-dropdown"
      >
        <div
          style={{
            fontFamily: selectedValue?.family,
            fontWeight: selectedValue?.weight,
            fontStyle: selectedValue?.style,
          }}
        >
          {selectedValue?.name}
        </div>
        <UpDownChevron up={showMenu} ratio={0.7} />
      </div>
      {showMenu && (
        <div className="dropdown_menu">
          <div className="dropdown_menu__lower">
            <FontsDropdown
              placeHolder="ALL FONTS"
              onChange={onChangeHandler}
              selectedFont={selectedValue}
              recentlyUsedFonts={recentlyUsedFonts}
            />
          </div>
        </div>
      )}
    </div>
  );
};
